import { Meal } from "@/clients/models/Meal";
import { MealTime } from "@/clients/models/MealTime";
import { BackButton } from "@/components/toolbar/back-button";
import { cn } from "@/utils/cn";
import { memo } from "react";
import { DislikeMealButton } from "../dislike-meal-button";
import { EditMealButton } from "../edit-meal-button";
import { LikeMealButton } from "../like-meal-button";

interface MealDetailHeaderProps {
  meal: Meal;
  mealTime: MealTime | undefined;
  likeable?: boolean;
  editable?: boolean;
  onBack?: () => void;
  /** Called when the user taps the edit button (Your Food only); use to open the edit recipe modal */
  onEditClick?: () => void;
}

export const MealDetailHeader = memo(function MealDetailHeader({
  meal,
  mealTime,
  likeable,
  editable,
  onBack,
  onEditClick,
}: MealDetailHeaderProps) {
  const renderLikeMealButton = () => {
    if (!editable && !likeable) return null;

    return (
      <div className="flex h-11 items-center justify-between rounded-full bg-white/76 px-1.5">
        {editable && (
          <EditMealButton
            className="h-11 w-11 rounded-full"
            ariaLabel="Edit meal nutrition"
            onEdit={onEditClick}
          />
        )}
        {likeable && (
          <>
            <LikeMealButton
              meal={meal}
              mealTime={mealTime}
              className="flex-1 p-0"
              filledColor="red"
            />
            <DislikeMealButton meal={meal} className="flex-1 p-0" />
          </>
        )}
      </div>
    );
  };

  return (
    <div
      className={cn(
        "fixed top-0 right-0 left-0 z-20 flex items-center justify-between px-4",
        "pt-[calc(var(--safe-area-inset-top)+0.5rem)]",
      )}
    >
      <BackButton onBack={onBack} />

      {renderLikeMealButton()}
    </div>
  );
});
